import { Card } from '@/components/atoms/Card';
import TossGuideImg1 from '@/assets/images/toss-key-guide-1.png';
import TossGuideImg2 from '@/assets/images/toss-key-guide-2.png';
import TossGuideImg3 from '@/assets/images/toss-key-guide-3.png';
import TossGuideImg4 from '@/assets/images/toss-key-guide-4.png';
import { toast } from 'react-toastify';

const TOSS_IP_ADDRESSES = ['13.124.61.168', '3.34.167.151', '1.227.58.121'] as const;
const TOSS_IP_ADDRESS_TEXT = TOSS_IP_ADDRESSES.join('\n');

export const TossGuide = () => {
  return (
    <Card className="space-y-[30px] p-[30px]">
      {GuideItems.map((item) => (
        <div className="space-y-5" key={item.number}>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex gap-1.5">
                <Badge label={item.number} />
                <div className="mt-px">{item.title}</div>
              </div>
              {item.button && item.button}
            </div>
            {item.description && (
              <div className="pl-7 text-gr-800 Body5M14">{item.description}</div>
            )}
          </div>
          {item.image && (
            <div className="flex justify-center px-[30px]">
              <img src={item.image} className="w-full" />
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};

const Badge = ({ label }: { label: number }) => {
  return (
    <span className=" Caption2B12 flex h-[22px] w-[22px]  items-center justify-center rounded-[4px] bg-blue-400 text-white">
      {label}
    </span>
  );
};

const GuideItems = [
  {
    number: 1,
    title: (
      <>
        <span
          className="cursor-pointer font-bold"
          onClick={() => window.open('https://business.toss.im/account/sign-in')}
        >
          토스쇼핑 파트너스
        </span>{' '}
        접속
      </>
    ),
  },
  {
    number: 2,
    title: (
      <>
        <span className="font-bold">가맹점·계정 관리</span> 선택
      </>
    ),
    image: TossGuideImg1,
  },
  {
    number: 3,
    title: (
      <>
        <span className="font-bold">자체개발 {'>'} &apos;키 발급&apos;</span> 버튼 클릭
      </>
    ),
    image: TossGuideImg2,
  },
  {
    number: 4,
    title: (
      <>
        API를 호출할 IP 주소 입력 뒤 <span className="font-bold">&apos;발급&apos;</span> 버튼 클릭
      </>
    ),
    button: (
      <button
        type="button"
        className="hover:bg-primary-200 cursor-pointer rounded-[8px] bg-point-100 px-[8px] py-[4px] text-point-500 transition-colors Body5M14"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(TOSS_IP_ADDRESS_TEXT);
            toast(
              <div className="flex items-center gap-2">
                <span>✅</span> IP 주소 복사가 완료되었어요
              </div>,
            );
          } catch (error) {
            console.error(error);
          }
        }}
      >
        IP 주소 복사
      </button>
    ),
    description: (
      <>
        <div className="mb-[6px]">IP 주소</div>
        <div className="whitespace-pre-line">{TOSS_IP_ADDRESS_TEXT}</div>
      </>
    ),
    image: TossGuideImg3,
  },
  {
    number: 5,
    title: (
      <>
        발급받은 <span className="font-bold">Access Key, Secret Key</span>를 셀러박스에 입력
      </>
    ),
    image: TossGuideImg4,
  },
];
